import { request } from "services/api/util";

class CrmTriggerService {
  async getListCrmTrigger(params) {
    const config = {
      method: "get",
      url: `admin/crmTriggers`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailCrmTrigger(id) {
    const config = {
      method: "get",
      url: `admin/crmTriggers/${id}`,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createCrmTrigger(body) {
    const config = {
      method: "post",
      url: `admin/crmTriggers`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async updateCrmTrigger(body, id) {
    const config = {
      method: "put",
      url: `admin/crmTriggers/${id}`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new CrmTriggerService();
